// extracted by mini-css-extract-plugin
export default {"header-container-top":"q5YcRuuBCNS0G8oEpzFt","header-container":"RNkHDtTWnN1S3TUIsn8l","indice-quotes":"q5HDv3Yp0vsVPg6m81gV","search-symbol":"xSjbZafJSNCKtnF9aq1V"};